import SectionBox from "../layout/SectionBox";
import useEmblaCarousel from "embla-carousel-react";
import Autoplay from "embla-carousel-autoplay";
import { useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { useClientStore } from "../../store/clientStore";
import PageLoader from "../../components/atoms/PageLoader";

export default function ClientListSection() {
  const [loading, setLoading] = useState(true);
  const [emblaRef, emblaApi] = useEmblaCarousel(
    { loop: true, align: "start" },
    [Autoplay({ delay: 2000, stopOnInteraction: false })]
  );

  
  // "https://placehold.co/600x400"

  const location = useLocation();
  const lang = location.pathname.startsWith("/id") ? "id" : "en";

  const { clients, fetchClients } = useClientStore();

  // 🔹 fetch client dari API
  useEffect(() => {
    fetchClients(lang).finally(() => setLoading(false));
  }, [fetchClients, lang]);

  useEffect(() => {
    if (emblaApi) emblaApi.reInit();
  }, [emblaApi, clients.length]);

  if (!clients.length) return null;

  return (
    <div className="container-section mx-auto px-6 pt-6">
        {loading && <PageLoader />}
      <SectionBox
        title={
          lang === "id"
            ? "Klien kami untuk bekerja sama"
            : "Our cool clients to work with"
        }
        titleAlign="center"
        titleClassName="text-2xl md:text-3xl text-black"
        background="#FFFFFF"
      >
        <div className="overflow-hidden" ref={emblaRef}>
          <div className="flex">
            {clients.map((client) => (
              <div
                key={client.id}
                className="
                  flex-[0_0_50%]
                  sm:flex-[0_0_33.33%]
                  lg:flex-[0_0_20%]
                  flex items-center justify-center p-4
                "
              >
                <img
                  src={client.client_image}
                  alt={`client-${client.id}`}
                  className="max-h-32 object-contain"
                />
              </div>
            ))}
          </div>
        </div>
      </SectionBox>
    </div>
  );
}
